import type { SensoreDigitaleDTO } from '../../dto/plc/sensore-digitale-dto'
import type { DigitalSensor } from '../../types/plc/digital-sensor'
import { calculateSensorName } from './sensor-name-calculator'

const mapToDigitalSensor = (dto: SensoreDigitaleDTO): DigitalSensor => {
    return {
        id: dto.id,
        group: dto.gruppo ?? undefined,
        position: dto.posizione ?? undefined,
        name: calculateSensorName(dto),
        enabled: dto.abilitato,
        normallyClosed: dto.normallyClosed,
        inputType: dto.inputType,
        counterMultiplier: dto.counterMultiplier,
        durationChecker: dto.tdurataChecker ?? undefined,
        successChecker: dto.successChecker,
        digitalFrequency: dto.tDigitalFrequency ?? undefined,
        digitalResetFrequency: dto.tDigitalResetFrequency ?? undefined,
        maxThreshold: dto.rMaxThreashold,
        minThreshold: dto.rMinThreashold,
        inputPin: dto.inputPin,
        outputPin: dto.outputPin,
        outputType: dto.outputType,
        outputPulseTime: dto.outputPulseTime ?? undefined,
        uom: dto.um ?? undefined,
        minScale: dto.fondoScalaMin,
        maxScale: dto.fondoScalaMax,
        number: dto.numero,
        decimals: dto.decimals,
        identifier: dto.aliasId ?? undefined,
    }
}

const mapToSensoreDigitaleDTO = (sensor: DigitalSensor): SensoreDigitaleDTO => {
    return {
        id: sensor.id,
        gruppo: sensor.group ?? null,
        posizione: sensor.position ?? null,
        aliasId: sensor.identifier ?? null,
        abilitato: sensor.enabled,
        normallyClosed: sensor.normallyClosed,
        inputType: sensor.inputType,
        counterMultiplier: sensor.counterMultiplier,
        tdurataChecker: sensor.durationChecker ?? null,
        successChecker: sensor.successChecker,
        tDigitalFrequency: sensor.digitalFrequency ?? null,
        tDigitalResetFrequency: sensor.digitalResetFrequency ?? null,
        rMaxThreashold: sensor.maxThreshold,
        rMinThreashold: sensor.minThreshold,
        inputPin: sensor.inputPin,
        outputPin: sensor.outputPin,
        outputType: sensor.outputType,
        outputPulseTime: sensor.outputPulseTime ?? null,
        um: sensor.uom ?? null,
        fondoScalaMin: sensor.minScale,
        fondoScalaMax: sensor.maxScale,
        numero: sensor.number,
        decimals: sensor.decimals
    }
}

export { mapToDigitalSensor, mapToSensoreDigitaleDTO }
